import React, { Component } from 'react';
import Connect from '../../../components/Forms/Connect';
import logo from '../../../assets/logo.svg';
import VimeoEmbed from '../../../components/VimeoEmbed/VimeoEmbed';

class SimplySelfFundedLanding extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Simply Self-Funded',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <article id='whitepapers' className='lp'>
        <div id='banner'>
          <div className='wrap'>
            <img src={logo} alt='CDPHP' className='logo' />
            <h1>Simply Self-Funded<sup>SM</sup> from&nbsp;CDPHP</h1>
            <p>The smarter way to self-fund—no learning curve required.</p>
          </div>
        </div>
        <section>
          <div className='wrap'>
            <main>
              <p>For many employers, self-funding is unfamiliar territory. It&rsquo;s a model with real potential, but it&rsquo;s often seen as time-consuming and hard to manage.</p>
              <p>Simply Self-Funded changes that. It&rsquo;s built for ease from day one—no setup fees, no complicated administration, and stop-loss protection. You get all the benefits of self-funding, with the simplicity and support of a fully insured plan.</p>
              <div className='inline-video'>
                <VimeoEmbed videoId='1218026543' hash='266b3963e6'
                  title='CDPHP Simply Self-Funded' />
              </div>
              <h3>For groups of 101+ employees, Simply Self-Funded offers:</h3>
              <ul>
                <li>No setup or upfront admin fees*</li>
                <li>Stop loss policy shopping and administration</li>
                <li>Cost containment programs</li>
                <li>Reporting and data insights</li>
                <li>Streamlined administration and billing</li>
                <li>Support from an expert service team</li>
                <li>High-quality benefits your employees will love</li>
              </ul>
              <p>See how simple self-funding can be—book your free consultation today!</p>
              <p className='disclaimer'>*CDPHP will retain Rx rebates to cover administration fee with minimum requirements based on group size.</p>
            </main>
            <aside>
              <Connect
                area='LargeGroupDownload'
                heading='Schedule a free consultation'
                subheading={false}
                gaEventLabel='Plans - Simply Self-Funded'
                submitText='Request Consult'
                displayInline />
            </aside>
          </div>
        </section>
      </article>
    );
  }
}

export default SimplySelfFundedLanding;